import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../App.jsx';
import { BrandMark } from '../components/Brand.jsx';
import ThemeToggle from '../components/ThemeToggle.jsx';
import PlanIllustration from '../components/PlanIllustration.jsx';
import Icon from '../components/Icon.jsx';

export default function Login() {
  const { user, ready, setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [firstEver, setFirstEver] = useState(false);

  const back = loc.state?.from || '/';

  useEffect(() => { if (ready && user) nav(back, { replace: true }); }, [ready, user, nav, back]);

  useEffect(() => {
    let live = true;
    api.auth.setupStatus()
      .then(d => { if (live && d.needsSetup) { setFirstEver(true); setMode('setup'); } })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  async function submit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const r = mode === 'login' ? await api.auth.login(email, password) : await api.auth.setup(email, name, password);
      setUser(r.user);
      nav(back, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centred auth-page">
      <aside className="auth-intro">
        <BrandMark />
        <div className="auth-story"><span className="eyebrow">Camera coverage, considered.</span><h2>Know what your<br />cameras will see.</h2><p>Bring your floor plan, devices, and coverage requirements together in one workspace.</p><PlanIllustration /><div className="auth-features"><span><Icon name="check" size={16} />Plan every viewpoint</span><span><Icon name="check" size={16} />Review in 2D and 3D</span><span><Icon name="check" size={16} />Deliver a clear installation plan</span></div></div>
        <span className="auth-intro-footer">Avisera Planner · Camera coverage planning</span>
      </aside>
      <div className="auth-form-area">
      <div className="card auth-card">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1 }} />
          <ThemeToggle />
        </div>

        <h1>{mode === 'login' ? 'Sign in' : 'Set up Avisera Planner'}</h1>
        <p className="sub">
          {mode === 'login'
            ? 'Your sites, camera library and share links live with your account.'
            : 'Create the one System Administrator account. It will create companies and their first owner accounts.'}
        </p>

        {error && <div className="formerror">{error}</div>}

        <form onSubmit={submit}>
          {mode === 'setup' && (
            <div className="field">
              <label htmlFor="lg-name">Name</label>
              <input id="lg-name" value={name} onChange={e => setName(e.target.value)}
                autoComplete="name" required maxLength={80} />
            </div>
          )}
          <div className="field">
            <label htmlFor="lg-email">Email</label>
            <input id="lg-email" type="email" value={email} onChange={e => setEmail(e.target.value)}
              autoComplete="username" required />
          </div>
          <div className="field">
            <label htmlFor="lg-pass">Password</label>
            <input id="lg-pass" type="password" value={password} onChange={e => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'} required
              minLength={mode === 'setup' ? 10 : undefined} />
            {mode === 'setup' && (
              <p className="hint">At least 10 characters. A short phrase beats a mangled word.</p>
            )}
          </div>
          <button className="btn primary wide" type="submit" disabled={busy}>
            {busy ? 'Working…' : mode === 'login' ? 'Sign in' : 'Create System Administrator'}
          </button>
        </form>

        {!firstEver && <div className="foot">Accounts are created by your company administrator.</div>}
      </div>
      <p className="auth-note"><Icon name="shield" size={15} />Your sites stay private until you choose to share them.</p>
      </div>
    </div>
  );
}
